import { layoutList } from '@/pages/home/data';

export default function LayoutGrid() {
  return (
    <section id="layout" className="scroll-mt">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-widest text-secondary-600">
              <span className="font-display text-sm font-black text-primary-500">03</span>
              <span className="h-px w-6 bg-background-400" />
              版式灵感
            </div>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              海报版式参考，图文并茂好上手
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            不看纯色卡，直接看整版怎么排：跨栏、出血、栅格拼贴、超大字，图文一起给，版式灵感一眼到位。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {layoutList.map((item, i) => (
            <a
              key={item.id}
              href="#layout"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative h-64 w-full overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`黑料色${item.title}版式灵感`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 flex h-7 items-center whitespace-nowrap rounded-full bg-foreground-950/85 px-2.5 text-xs font-medium text-background-50">
                  {item.grid}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-display text-xs font-black text-primary-500">
                    LAYOUT / {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-fire-fill text-[13px] text-accent-500" />
                    热度 {item.heat}
                  </span>
                </div>
                <h3 className="mt-2 font-display text-base font-bold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-1.5 flex-1 text-sm leading-6 text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-t border-background-300/60 pt-3">
                  <div className="flex flex-wrap gap-1.5">
                    {item.tags.map((t) => (
                      <span
                        key={t}
                        className="flex h-6 items-center whitespace-nowrap rounded-full bg-secondary-100 px-2.5 text-xs text-secondary-800"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <i className="ri-arrow-right-line text-foreground-300 transition-colors group-hover:text-primary-500" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}